import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { useParams,Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import './ProductStyle.css';
import { updateProduct} from '../../redux/actions/Product/ProductActions';
import { getProductById } from '../../redux/actions/Product/ProductActions';
import {Zoom } from 'react-toastify';
const UpdateProductBy = ({products,getProductById,updateProduct}) =>{

    const [productName, setProductName]=useState(products.productName);
    const [productDescription, setProductDescription]=useState(products.productDescription);
    const [productQuantity, setProductQuantity]=useState(products.productQuantity);
    const [productType, setProductType]=useState(products.productType);
    const [date, setDate]=useState(products.date);

    //const history = useHistory();
    const params=useParams();
    useEffect(()=> {
        //if(products&& products.length ===0)
        getProductById(params.id);
        console.log(products);
        
    },
    []);
    const HandleClose = () =>{

        window.location.href = '/product/all';
    };
    const HandleSubmit = (e) => {
        e.preventDefault();
        if(productName && productQuantity){
            updateProduct(params.id,{productName, productDescription, productQuantity, productType, date});
            toast.success('Product added successfully!!');
            setTimeout(function () {
                window.location.href = '/product/all'; //will redirect to your blog page (an ex: blog.html)
            }, 3000);
            
        }
        else{
            toast.error('Field can not be left empty', {autoClose:6000},{
                transition: Zoom
            });
        }
    };
    useEffect(()=>{
        console.log(products);
        setProductName(products.productName);
        setProductDescription(products.productDescription);
        setProductQuantity(products.productQuantity);
        setProductType(products.productType);
        setDate(products.date);
    },[products]);
    
    return(
        
        <div className="container-fluid add-product-page">
            <h4 className="text-center  py-2 add-product-header">Update Product</h4>
            <div className="row">
                <div className="col-md-6 p-5 mx-auto shadow add-product-form">
                    <form onSubmit={HandleSubmit}>
                        <div className="form-group my-3">
                            <input
                                className="form-control"
                                type="text"
                                placeholder="*Product Name"
                                value={productName}
                                onChange={(e)=> setProductName(e.target.value)}
                            />
                        </div>
                        <div className="form-group my-3">
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Product Description"
                                value={productDescription}
                                onChange={(e)=>setProductDescription(e.target.value)}
                            />
                        </div>
                        <div className="form-group my-3">
                            <input
                                className="form-control"
                                type="number"
                                placeholder="*Quantity"
                                value={productQuantity}
                                onChange={(e)=>setProductQuantity(e.target.value)}
                            />
                        </div>
                        <div className="form-group my-3">
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Product Type"
                                value={productType}
                                onChange={(e)=>setProductType(e.target.value)}
                            />
                        </div>
                        <div className="form-group my-3">
                            <input
                                className="form-control"
                                type="date"
                                placeholder="Date"
                                value={date}
                                onChange={(e)=>setDate(e.target.value)}
                            />
                        </div>
                        <div className='add-product-buttons'>
                            <div className="form-group my-3 ">
                                <button type="submit" className="btn btn-primary">
                                    Submit
                                </button>
                            </div>
                            <div className="form-group my-3 ">
                                <Link className="btn btn-primary" onClick={HandleClose}>
                                    Go Back
                                </Link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};
const mapStateToProps = (state) => {
    console.log(state);
    return {
        products: state.products
    };
};

const mapDispatchToProps = {
    getProductById,
    updateProduct,
};


export default connect(mapStateToProps, mapDispatchToProps)(UpdateProductBy);